/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, createRef } from 'react'
import PropTypes from 'prop-types'
import { Chevron2Icon, SortIcon, Cross2Icon } from '../icons'
import { DropdownMenuStyles as styles } from './styles'
import DropdownMenuItem from './DropdownMenuItem'

const DropdownMenu = (props) => {
  const [state, setState] = useState({
    isExpanded: false,
    menuHeight: 0,
  })
  const [headerVisible, setHeaderVisible] = useState(false)
  const menuRef = createRef()

  useEffect(() => {
    const listener = (event) => {
      // Do nothing if clicking ref's element or descendent elements
      if (!menuRef.current || menuRef.current.contains(event.target)) {
        return
      }
      setState({
        isExpanded: false,
        menuHeight: window.screen.height / 2,
      })
    }
    document.addEventListener('mousedown', listener)
    return () => {
      document.removeEventListener('mousedown', listener)
    }
  }, [menuRef])

  useEffect(() => {
    document.getElementById('sectionId').scrollTop = 0
    // eslint-disable-next-line no-unused-expressions
    state.isExpanded ? document.body.classList.add('no-scroll') : document.body.classList.remove('no-scroll')

    if (window && window.innerWidth <= 768) {
      const header = document.getElementsByClassName('PageHeader')[0]

      if (state.isExpanded) {
        // store header was visible when menu opened and hide it
        setHeaderVisible(!!header.classList.contains('scroll-up'))
        header.classList.remove('scroll-up')
        header.classList.add('scroll-down')
      } else {
        // eslint-disable-next-line no-lonely-if
        if (headerVisible) {
          header.classList.remove('scroll-down')
          header.classList.add('scroll-up')
        }
      }
    }
  }, [state.isExpanded])

  const toggleMenu = () => {
    setState({
      isExpanded: !isExpanded,
      menuHeight: window.screen.height / 2,
    })
  }

  const itemOnClick = (e) => {
    toggleMenu()
    props.closeMenu(e)
  }

  const { isExpanded } = state
  const expandedHeight = `${state.menuHeight}px`
  const splitItemsIntoColumns = (items, itemsPerColumn = 8) => {
    const columns = []
    for (let i = 0; i < items.length; i += itemsPerColumn) {
      columns.push(items.slice(i, i + itemsPerColumn))
    }
    return columns
  }

  const itemColumns = splitItemsIntoColumns(props.menuItems).map(column => (
    <div key={`column-${column[0]?.title || 'empty'}`} className="menu-column">
      {column.map(data => (
        <DropdownMenuItem
          {...data}
          customClassName={data.customClassName || ''}
          key={data.title}
          theme={data.theme}
          isTvGuide={props.isTvGuide}
          DropdownMenuHasTitle={Boolean(data.title)}
          onClick={(e) => {
            itemOnClick(e)
            document.getElementById('sectionId').scrollTop = 0
          }}
        />
      ))}
    </div>
  ))

  const classNameSuffix = props.page ? `${props.page} ${props.theme}` : props.theme

  return (
    <section
      id="sectionId"
      className={`DropdownMenu ${classNameSuffix} ${props.className} ${props.isTvGuide ? 'tv-guide' : ''} ${isExpanded ? 'active' : ''}`}
      style={{
        ...(isExpanded && {
          height: 'auto',
          maxHeight: expandedHeight,
          overflowY: 'auto',
          zIndex: 1,
        }),
      }}
    >
      <div
        id={props.id}
        className={`wrapper ${props.isTvGuide ? 'tv-guide' : ''}`}
        ref={menuRef}

      >
        { props.title && (
          <span className={`title ${props.isTvGuide ? 'tv-guide' : ''} `} onClick={toggleMenu}>
            <span className="innerTitle">
              { props.isSortMenu && (
                <span className="sort-icon">
                  <SortIcon />
                </span>
              )}
              <h4>{(props.isTvGuide || props.isLivePage) ? 'Channel:' : ''} {props.title}</h4>
              { !props.isSortMenu && (
                <span
                  className={[
                    'chevron-icon',
                    isExpanded && 'is-expanded',
                  ].filter(Boolean).join(' ')}
                >
                  <Chevron2Icon direction="down" />
                </span>
              )}
            </span>
          </span>
        ) }
        <div className={`menu ${props.className} ${props.isTvGuide ? 'tv-guide' : ''} ${props.isLivePage ? 'live-page' : ''} ${isExpanded ? 'active' : ''}`}>
          <div className={`overlay-header ${props.className}`}>
            {props.subTab
              ? <h3>{'Select Series'}</h3>
              : (props.isTvGuide || props.isLivePage) ? <h3>{'Select Channel'}</h3> : <h3>{props.isSortMenu ? 'Sort By' : 'Select Category'}</h3>}
            <span className="overlayCloseButton" onClick={toggleMenu}>
              <Cross2Icon />
            </span>
          </div>
          { itemColumns }
        </div>
      </div>

      <style jsx>{styles}</style>
    </section>
  )
}

DropdownMenu.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  theme: PropTypes.oneOf(['horizontal', 'vertical']),
  page: PropTypes.oneOf([null, 'live']),
  menuItems: PropTypes.arrayOf(PropTypes.object), // eslint-disable-line react/forbid-prop-types
  closeMenu: PropTypes.func,
  activeState: PropTypes.bool,
  className: PropTypes.string,
  isSortMenu: PropTypes.bool,
  isTvGuide: PropTypes.bool,
  isLivePage: PropTypes.bool,
  subTab: PropTypes.bool,
}

DropdownMenu.defaultProps = {
  id: '',
  title: '',
  theme: 'vertical',
  menuItems: [{}],
  page: null,
  closeMenu: () => { },
  activeState: false,
  className: '',
  isSortMenu: false,
  isTvGuide: false,
  isLivePage: false,
  subTab: false,
}

export default DropdownMenu
